export const actionTypes = {
  SET_LOGIN_DATA: "SET_LOGIN_DATA",
  SET_LOGOUT: "SET_LOGOUT",
  SET_SELECTED_SITE: "SET_SELECTED_SITE",
  SET_SELECTED_COMPANY: "SET_SELECTED_COMPANY",
  SET_SHOW_ALERT: "SET_SHOW_ALERT",
  SET_SHOW_REPORT: "SET_SHOW_REPORT",
  SET_LOCATION_FOR_GLOBAL_SEARCH: "SET_LOCATION_FOR_GLOBAL_SEARCH",
  SET_SELECTED_CLIENT_DATA: "SET_SELECTED_CLIENT_DATA",
  SET_SHOW_ADD_PROJECT: "SET_SHOW_ADD_PROJECT",
  SET_SHOW_ADD_EXPERIENCE: "SET_SHOW_ADD_EXPERIENCE",
  SET_SELECTED_PROJECT_DATA: "SET_SELECTED_PROJECT_DATA",
  SET_PROJECT_IMAGES: "SET_PROJECT_IMAGES",
  SET_SHOW_MAP_MODAL: "SET_SHOW_MAP_MODAL",
  SET_BUILDER_BUCKS_COUNT: "SET_BUILDER_BUCKS_COUNT",
  SET_CHAT_COUNT: "SET_CHAT_COUNT",
  SET_CLIENT_CHAT_COUNT: "SET_CLIENT_CHAT_COUNT",
  SET_PROJECT_LIST_UPDATE: "SET_PROJECT_LIST_UPDATE",
  SET_SELECT_LOCATION: "SET_SELECT_LOCATION",
  SET_MENU_CARD_BUILDER_BUCKS: "SET_MENU_CARD_BUILDER_BUCKS",
  SET_NO_LOCATION_COUNT: "SET_NO_LOCATION_COUNT",
  SET_MAIN_NOTIFICATION: "SET_MAIN_NOTIFICATION",
  SET_PREVIOUS_QUESTION_ID: "SET_PREVIOUS_QUESTION_ID",
  SET_SELECTED_SITE_ID: "SET_SELECTED_SITE_ID",
  SET_SELECTED_MONTAGE: "SET_SELECTED_MONTAGE",
  SET_SHOW_ADDPOST: "SET_SHOW_ADDPOST",
  SET_CHAT_STATE: "SET_CHAT_STATE",
  SET_SELETED_CHAT_STATE: "SET_SELETED_CHAT_STATE",
  RESET_SELETED_CHAT_STATE: "RESET_SELETED_CHAT_STATE",
  SET_CHAT_GROUPS: "SET_CHAT_GROUPS",
  SET_SELECTED_CHAT: "SET_SELECTED_CHAT",
  SET_MULTILANGUAGE_DATA: "SET_MULTILANGUAGE_DATA",
  SET_MULTILANGUAGE_CODE: "SET_MULTILANGUAGE_CODE",
  SET_SHOW_EXPORT_MODEL: "SET_SHOW_EXPORT_MODEL",
  SET_DASHBOARD_DATA: "SET_DASHBOARD_DATA",
  SET_NO_LOCATION_SITES: "SET_NO_LOCATION_SITES",
  SET_SURVEY_LATER_TODAY: "SET_SURVEY_LATER_TODAY",
  SET_CHOOSE_SITE: "SET_CHOOSE_SITE",
  SET_LICENSES: "SET_LICENSES",
  SET_NO_LICENSE_ACCESS: "SET_NO_LICENSE_ACCESS",
  SET_REFRESH_MAP_DATA: "SET_REFRESH_MAP_DATA",
  SET_GET_CLIENT_DATA: "SET_GET_CLIENT_DATA",
  SET_PICTURE_BOARD_DATA: "SET_PICTURE_BOARD_DATA",
  SET_REPORT_SUCCESS: "SET_REPORT_SUCCESS",
  SET_IS_CARPOOL_OPT_OUT: "SET_IS_CARPOOL_OPT_OUT",
  SET_CARPOOL_SELECTED_SITE: "SET_CARPOOL_SELECTED_SITE",
  SET_CARPOOL_SWITCH_VALUE: "SET_CARPOOL_SWITCH_VALUE",
  SET_CARPOOL_POSTAL_CODE: "SET_CARPOOL_POSTAL_CODE",
  CLEAR_CARPOOL_STATE: "CLEAR_CARPOOL_STATE",
  RESET_CHAT_STATE: "RESET_CHAT_STATE",
  SET_OPEN: "SET_OPEN",
  SET_SELECTED_USERS: "SET_SELECTED_USERS",
  SET_FROM: "SET_FROM",
  SET_JOB_SELECTED_LOCATION: "SET_JOB_SELECTED_LOCATION",
  SET_SHOW_ORGANIZATION_MODAL: "SET_SHOW_ORGANIZATION_MODAL",
  SET_COMMUNITY_POST_IDS: "SET_COMMUNITY_POST_IDS",
  ADD_COMMUNITY_POST_IDS: "ADD_COMMUNITY_POST_IDS",
  CLEAR_COMMUNITY_POST_IDS: "CLEAR_COMMUNITY_POST_IDS",
  SET_LAST_SYNC_COMMUNITY_TIME: "SET_LAST_SYNC_COMMUNITY_TIME",
  SET_OPEN_NOTIFICATION_MENU: "SET_OPEN_NOTIFICATION_MENU",
  SET_SELECTED_APP_PERMISSIONS: "SET_SELECTED_APP_PERMISSIONS"
};

export const setLogindata = (payload) => {
  return {
    type: actionTypes.SET_LOGIN_DATA,
    payload: {
      ...payload,
      ChatLanguage: payload.ChatLanguage ?? "en",
      TranslateMessage: payload.TranslateMessage ?? false
    }
  };
};

export const setLogout = (payload) => {
  return {
    type: actionTypes.SET_LOGOUT,
    payload: payload
  };
};

export const setSelectedsite = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_SITE,
    payload: payload
  };
};
export const setSelectedcompany = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_COMPANY,
    payload: payload
  };
};
export const setShowaddproject = (payload) => {
  return {
    type: actionTypes.SET_SHOW_ADD_PROJECT,
    payload: payload
  };
};
export const setShowExport = (payload) => {
  return {
    type: actionTypes.SET_SHOW_EXPORT_MODEL,
    payload: payload
  };
};
export const setShowaddexperience = (payload) => {
  return {
    type: actionTypes.SET_SHOW_ADD_EXPERIENCE,
    payload: payload
  };
};
export const setShowalert = (payload) => {
  return {
    type: actionTypes.SET_SHOW_ALERT,
    payload: payload
  };
};

export const setShowReport = (payload) => {
  return {
    type: actionTypes.SET_SHOW_REPORT,
    payload: payload
  };
};
export const setLocationForGlobalSearch = (payload) => {
  return {
    type: actionTypes.SET_LOCATION_FOR_GLOBAL_SEARCH,
    payload: payload
  };
};
export const setSelectedClientdata = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_CLIENT_DATA,
    payload: payload
  };
};
export const setSelectedProjectdata = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_PROJECT_DATA,
    payload: payload
  };
};

// Project Images
export const setProjectimages = (payload) => {
  return {
    type: actionTypes.SET_PROJECT_IMAGES,
    payload: payload
  };
};

// Show map modal
export const setShowmapmodal = (payload) => {
  return {
    type: actionTypes.SET_SHOW_MAP_MODAL,
    payload: payload
  };
};

export const setBuilderBucksCount = (payload) => {
  return {
    type: actionTypes.SET_BUILDER_BUCKS_COUNT,
    payload: payload
  };
};
export const setChatCount = (payload) => {
  return {
    type: actionTypes.SET_CHAT_COUNT,
    payload: payload
  };
};

export const setClientChatCount = (payload) => {
  return {
    type: actionTypes.SET_CLIENT_CHAT_COUNT,
    payload: payload
  };
};

export const setNoLocationSites = (payload) => {
  return {
    type: actionTypes.SET_NO_LOCATION_SITES,
    payload: payload
  };
};

export const setSiteprojects = (payload) => {
  return {
    type: actionTypes.SET_PROJECT_LIST_UPDATE,
    payload: payload
  };
};

export const setMenuCardBuilderBucks = (payload) => {
  return {
    type: actionTypes.SET_MENU_CARD_BUILDER_BUCKS,
    payload: payload
  };
};

export const setSelectlocation = (payload) => {
  return {
    type: actionTypes.SET_SELECT_LOCATION,
    payload: payload
  };
};

// Set No Location Count
export const setNolocationcount = (payload) => {
  return {
    type: actionTypes.SET_NO_LOCATION_COUNT,
    payload: payload
  };
};
export const setMainNotification = (payload) => {
  return {
    type: actionTypes.SET_MAIN_NOTIFICATION,
    payload: payload
  };
};

export const setPreviousQuestionId = (payload) => {
  return {
    type: actionTypes.SET_PREVIOUS_QUESTION_ID,
    payload: payload
  };
};

export const setSelectedSiteId = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_SITE_ID,
    payload: payload
  };
};

export const setSelectedMontage = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_MONTAGE,
    payload: payload
  };
};

export const showAddPostModal = (payload) => {
  return {
    type: actionTypes.SET_SHOW_ADDPOST,
    payload: payload
  };
};

// Action to store chat state
export const setChatState = (payload) => {
  return {
    type: actionTypes.SET_CHAT_STATE,
    payload
  };
};
export const setDashboardData = (payload) => {
  return {
    type: actionTypes.SET_DASHBOARD_DATA,
    payload
  };
};
export const setMultiLanguageData = (payload) => {
  return {
    type: actionTypes.SET_MULTILANGUAGE_DATA,
    payload
  };
};

export const setMultiLanguageCode = (payload) => {
  return {
    type: actionTypes.SET_MULTILANGUAGE_CODE,
    payload
  };
};

export const setSurveyLaterToday = (payload) => {
  return {
    type: actionTypes.SET_SURVEY_LATER_TODAY,
    payload
  };
};

export const setChoosesite = (payload) => {
  return {
    type: actionTypes.SET_CHOOSE_SITE,
    payload
  };
};
export const setLicences = (payload) => {
  return {
    type: actionTypes.SET_LICENSES,
    payload
  };
};

export const setNoLicenseAccess = (payload) => {
  return {
    type: actionTypes.SET_NO_LICENSE_ACCESS,
    payload
  };
};

export const setReportSuccess = (payload) => {
  return {
    type: actionTypes.SET_REPORT_SUCCESS,
    payload
  };
};

export const setGetClientData = (payload) => {
  return {
    type: actionTypes.SET_GET_CLIENT_DATA,
    payload
  };
};
export const setPictureBoardData = (payload) => {
  return {
    type: actionTypes.SET_PICTURE_BOARD_DATA,
    payload
  };
};

export const setCarpoolOptLoader = (payload) => {
  return {
    type: actionTypes.SET_IS_CARPOOL_OPT_OUT,
    payload
  };
};

export const setCarpoolSwitchValue = (payload) => {
  return {
    type: actionTypes.SET_CARPOOL_SWITCH_VALUE,
    payload
  };
};

export const clearCarpoolState = () => {
  return {
    type: actionTypes.CLEAR_CARPOOL_STATE
  };
};

// Action to reset chat state
export const resetChatState = () => {
  return {
    type: actionTypes.RESET_CHAT_STATE
  };
};

export const setOpen = (payload) => {
  return {
    type: actionTypes.SET_OPEN,
    payload: payload
  };
};

export const setSelectedUsers = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_USERS,
    payload: payload
  };
};

export const setfrom = (payload) => {
  return {
    type: actionTypes.SET_FROM,
    payload
  };
};

export const setJobSelectedLocation = (payload) => {
  return {
    type: actionTypes.SET_JOB_SELECTED_LOCATION,
    payload
  };
};

export const setShowOrganizationModal = (payload) => {
  return {
    type: actionTypes.SET_SHOW_ORGANIZATION_MODAL,
    payload
  };
};

export const setChatGroups = (payload) => {
  return {
    type: actionTypes.SET_CHAT_GROUPS,
    payload
  };
};

export const setSelectedChat = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_CHAT,
    payload
  };
};

export const setCommunityPostIds = (payload) => {
  return {
    type: actionTypes.SET_COMMUNITY_POST_IDS,
    payload
  };
};

export const addCommunityPostIds = (payload) => {
  return {
    type: actionTypes.ADD_COMMUNITY_POST_IDS,
    payload
  };
};

export const clearCommunityPostIds = () => {
  return {
    type: actionTypes.CLEAR_COMMUNITY_POST_IDS
  };
};

export const setLastSyncCommunityTime = (payload) => {
  return {
    type: actionTypes.SET_LAST_SYNC_COMMUNITY_TIME,
    payload
  };
};

export const setOpenNotificationMenu = (payload) => {
  return {
    type: actionTypes.SET_OPEN_NOTIFICATION_MENU,
    payload
  };
};

export const setSelectedAppPermissions = (payload) => {
  return {
    type: actionTypes.SET_SELECTED_APP_PERMISSIONS,
    payload
  };
}
